import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

export function ServiceDisclaimerCard({ className = "mb-4" }) {
    return (
        <div
            className={`card border rounded-4 shadow-sm bg-white ${className}`.trim()}
            style={{
                borderRadius: '15px'
            }}
        >
            <div className="card-body p-4">
                <div className="d-flex align-items-center gap-2 mb-2 text-primary">
                    <FontAwesomeIcon icon={faCircleInfo} />
                    <span className="fw-bold" style={{ fontSize: '0.95rem' }}>이용 안내</span>
                </div>
                <p
                    className="mb-0"
                    style={{
                        color: '#495057',
                        fontSize: '0.92rem',
                        lineHeight: '1.7',
                        wordBreak: 'keep-all'
                    }}
                >
                    본 사이트는 정보 제공 및 연결을 돕는 중개 플랫폼이며, 실제 서비스 제공 및 대금 지불은 당사자 간의 책임하에 이루어집니다.
                </p>
            </div>
        </div>
    );
}